import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import styled, { css } from "styled-components";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Zone from "@insite/client-framework/Components/Zone";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { injectCss } from "@insite/mobius/utilities";

const enum fields {
  backgroundColor = "backgroundColor",
  paddingTop = "paddingTop",
  paddingBottom = "paddingBottom",
}

interface OwnProps extends WidgetProps {
  fields: {
    backgroundColor: string;
    paddingTop: string;
    paddingBottom: string;
  }
}

interface CrescentPageContentContainer {
    container?: InjectableCss;
    wrapper?: InjectableCss;
}

const richContentStyles = {
  wrapper: {},
};

export const styles: CrescentPageContentContainer = {
    container: {
      css: css`
          ${({ theme }: { theme: BaseTheme }) =>
              breakpointMediaQueries(
                  theme,
                  [
                      css`
                          padding-right: 1rem;
                          padding-left: 1rem;
                          max-width: 100%;
                      `,
                      null,
                      null,
                      css`
                          padding-left: 80px;
                          padding-right: 80px;
                      `,
                  ],
                  "min",
              )}
      `,
  },
};

const CrescentPageContentContainer: FC<OwnProps> = ({ fields, id }) => {
  const { backgroundColor, paddingBottom, paddingTop } = fields;
    return (
      <StyledWrapper {...styles.container}>
        <ContentWrapper
          backgroundColor={backgroundColor}
          paddingBottom={paddingBottom}
          paddingTop={paddingTop}
        >
            <Zone zoneName="Content" contentId={id} />
        </ContentWrapper>
      </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CrescentPageContentContainer,
    definition: {
        group: "Common",
        displayName: "Page content Container",
        fieldDefinitions: [
          {
            fieldType: "General",
            name: fields.backgroundColor,
            editorTemplate: "ColorPickerField",
            displayName: "Background Color",
            defaultValue: "",
          },
          {
            fieldType: "General",
            name: fields.paddingTop,
            editorTemplate: "TextField",
            displayName: "Padding Top",
            defaultValue: "",
          },
          {
            fieldType: "General",
            name: fields.paddingBottom,
            editorTemplate: "TextField",
            displayName: "Padding Bottom",
            defaultValue: "",
          }
        ]
    },
};

export default widgetModule;

export const ContentWrapper = styled.div<{ backgroundColor: string; paddingTop: number | string; paddingBottom: number | string } & InjectableCss>`
    ${({ backgroundColor }) => (backgroundColor ? `background-color: ${backgroundColor};` : null)};
    ${({ paddingTop }) => (paddingTop ? `padding-top: ${paddingTop}px;` : null)};
    ${({ paddingBottom }) => (paddingBottom ? `padding-bottom: ${paddingBottom}px;` : null)};
    ${injectCss}
`;
